
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { formDownload } from "@common/src/utils/tools";
import dayjs from "dayjs";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import PrintDropdown from "./components/print-dropdown.vue";
const service = namespace("service");
const base = namespace("base");
const app = namespace("app");
const staff = namespace("staff");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
const inventory = namespace("inventory");

const typeMap: any = {
  maintenance: 1,
  wash: 2,
  retail: 3,
  all: ""
};
@InjectFunction("emptyToLine", "splitThousands", "addCurrencyUnit")
@Component({
  name: "ServiceList",
  components: { DataImport, CustomerFlag, TextTips, PrintDropdown }
})
@Table("loadListData", { pageSize: 5 })
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/speedbiz/template/2.7/订单导入模板.xlsx",
  actionUrl: "/filecloud/importOrder"
})
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @service.State currentTabType;
  @service.Mutation setCurrentTabType;
  @service.Action getOrderList;
  @service.Action getUri;
  @service.Action email;
  @service.Action sms;
  @service.Action onlineVerificationCode;
  @inventory.Action queryInventoryAndNotice;
  @service.Action completeOrder;
  @service.Action queryAllChannel;
  @base.Action getDictionaryList;
  @base.Mutation checkPageHasInstruction;
  @app.State country;
  @staff.Action getStaffList;
  @serviceItem.Action getServiceItemList;
  @parts.Action getPartsList;
  orderList: any = [];
  showPickingTips: boolean = false;
  searchForm = {
    orderTimeEnd: "",
    orderTimeStart: "",
    orderStatusList: [],
    searchKey: "",
    settlementStatus: "",
    technicianName: "",
    invoicingRequire: "", // 是否需要开票
    reservationArrivalTimeEnd: "",
    reservationArrivalTimeStart: "",
    orderSource: "", // 订单来源
    channelOrderNo: "", // 渠道订单号
    externalOrderNo: "", // 外部订单号
    partsCode: "",
    serviceCode: "",
    isArrival: "", // 0未到店,1到店
    saleCode: ""
  };
  get orderType() {
    const orderType = typeMap[this.currentTabType];
    if (this.currentTabType === "maintenance") {
      this.checkPageHasInstruction({
        resourceCode: "PC_ORDER_MAINTENANCE"
      });
    } else if (this.currentTabType === "wash") {
      this.checkPageHasInstruction({
        resourceCode: "PC_ORDER_CARWASH"
      });
    } else if (this.currentTabType === "retail") {
      this.checkPageHasInstruction({
        resourceCode: "PC_ORDER_RETAIL"
      });
    } else if (this.currentTabType === "all") {
      this.checkPageHasInstruction({
        path: "/service/index"
      }); // 全部服务
    }
    return orderType;
  }
  get breadData() {
    return [
      { name: t("test.service-management"), path: "/service" },
      {
        name: this.$route.name === "partsAdd" ? t("service.new-maintenance") : t("setting.editing-spare-parts")
      }
    ];
  }
  get tabBarData() {
    return [
      { tabName: t("service.all-services"), type: "all" },
      { tabName: t("service.maintenance-service"), type: "maintenance" },
      { tabName: t("service.car-wash-service"), type: "wash" },
      { tabName: t("service.retail-service"), type: "retail" }
    ];
  }
  orderStatusList: any[] = [];
  settlementList: any[] = [];
  orderSourceList: any[] = [];
  appointmentDate: any = [];
  partsList: any = [];
  serviceItemList: any = [];
  defaultExpand: boolean = false;
  created() {
    this.init();
  }

  get urlDate() {
    return (this.$route.query.date as string) || "";
  }
  init() {
    if (this.$route.query.type === "all") {
      this.setCurrentTabType("all");
    }
    // 根据url中时间设置筛选条件并查询
    if (this.urlDate) {
      this.appointmentDate = [`${this.urlDate}`, `${this.urlDate}`];
      this.searchForm.reservationArrivalTimeStart = this.urlDate;
      this.searchForm.reservationArrivalTimeEnd = this.urlDate;
      this.seletedStatus = "2";
      this.defaultExpand = true;
      this.searchForm.isArrival = "0";
      this.handleSearch(this.searchList, "keepIsArrival");
    } else {
      this.loadListData();
    }
    // 结算方式字典List
    this.getDictionaryList("settlement_status").then(data => {
      this.settlementList = data;
    });
    // 订单状态字典List
    this.getDictionaryList("order_status").then(data => {
      this.orderStatusList = data;
    });

    // 订单来源List
    this.queryAllChannel().then(data => {
      this.orderSourceList = data.data.map(item => {
        return {
          label: item.channelName,
          value: item.sourceCode
        };
      });
    });
    // this.getDictionaryList("order_source").then(data => {
    //   console.log("[ order_source ]", data);
    //   this.orderSourceList = data;
    // });
    // 员工和顾问 List
    this.getStaffList({
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      const staffList = this.$safeValue(data, "data.list", []).map(item => ({
        label: item.staffName,
        value: item.userCode
      }));
      this.staffList = staffList;
    });
    this.searchParts("");
    this.handleSearchServiceItemList("");
  }
  groupIndex: number = 1;
  @Table.LoadDataMethod()
  loadListData() {
    this.searchForm["orderType"] = this.orderType;
    return this.getOrderList({
      ...this.searchForm,
      clientType: "1",
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      let orderList = this.$safeValue(data, "data.list", []);
      orderList.forEach(item => {
        const serviceCodeMap = {}; // 存放映射关系
        let groupIndex = 1;
        item.partsDetail.forEach((parts, index) => {
          if (parts.serviceCode) {
            if (serviceCodeMap[parts.serviceCode]) {
              serviceCodeMap[parts.serviceCode].push(index);
            } else {
              serviceCodeMap[parts.serviceCode] = [index];
            }
          }
        });
        item.serviceDetail.forEach(serviceItem => {
          if (serviceCodeMap[serviceItem.serviceCode]) {
            serviceItem.isGroup = true;
            serviceItem.groupServiceIndex = groupIndex;
            serviceCodeMap[serviceItem.serviceCode].forEach(i => {
              item.partsDetail[i].isGroupParts = true;
              item.partsDetail[i].groupServiceIndex = groupIndex;
            });
            groupIndex++;
          }
        });
      });

      this.orderList = orderList;
      return data;
    });
  }
  handleSwitchStatus(tab) {
    this.setCurrentTabType(tab.type);
    this.mix_pageNum = 1;
    this.loadListData();
  }
  invoicingList: any[] = [];
  staffList: any[] = [];
  seletedStatus: string = "";
  get searchList() {
    return [
      {
        label: t("test.keyword"),
        type: "input",
        value: "",
        prop: "searchKey",
        placeholder: t("test.license-name-mobile-vincode")
      },
      {
        label: t("base.order-status"),
        type: "select",
        selectList: this.orderStatusList,
        value: this.seletedStatus,
        prop: "orderStatusList"
      },
      {
        label: t("base.settlement-status"),
        type: "select",
        selectList: this.settlementList,
        value: "",
        prop: "settlementStatus"
      },
      {
        label: t("service.need-invoice"),
        type: "select",
        selectList: [
          {
            label: t("base.yes"),
            value: "1"
          },
          {
            label: t("base.no"),
            value: "0"
          }
        ],
        value: "",
        prop: "invoicingRequire"
      },
      {
        label: t("finance.creation-time"),
        type: "daterange",
        value: "",
        prop: "createDate",
        valueDistribute: ["orderTimeStart", "orderTimeEnd"]
      },
      {
        label: t("v212.settlement-time"),
        type: "daterange",
        value: "",
        prop: "paidTime",
        valueDistribute: ["paidTimeBegin", "paidTimeEnd"]
      },
      {
        label: t("service.date-reservation"),
        type: "daterange",
        value: this.appointmentDate,
        prop: "reservationArrivalTime",
        valueDistribute: ["reservationArrivalTimeStart", "reservationArrivalTimeEnd"]
      },
      {
        label: t("dashboard.channel-for"),
        type: "select",
        selectList: this.orderSourceList,
        value: "",
        prop: "orderSource"
      },
      {
        label: t("service.channel-order-number"),
        type: "input",
        value: "",
        prop: "channelOrderNo",
        placeholder: ""
      },
      {
        label: t("service.external-order-number"),
        type: "input",
        value: "",
        prop: "externalOrderNo",
        placeholder: ""
      },
      {
        label: t("test.service-consultant"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "advisorCode"
      },
      {
        label: t("v210801.sales-consultant"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "saleCode"
      },
      {
        label: t("test.service-technician"),
        type: "select",
        selectList: this.staffList,
        value: "",
        prop: "technicianCode"
      },
      {
        label: t("finance.receipt-number"),
        type: "input",
        value: "",
        prop: "orderNo",
        placeholder: ""
      },
      {
        label: t("parts.text"),
        type: "select-search",
        value: "",
        prop: "partsCode",
        placeholder: t("v210901.enter-spare-parts-search"),
        selectList: this.partsList,
        searchFun: this.searchParts
      },
      {
        label: t("finance.service-items"),
        type: "select-search",
        value: "",
        prop: "serviceCode",
        placeholder: t("v210906.enter-service-item-keyword-query"),
        selectList: this.serviceItemList,
        searchFun: this.handleSearchServiceItemList
      }
    ];
  }
  handleSearch(data, opName?) {
    if (opName !== "keepIsArrival") {
      this.searchForm.isArrival = "";
    }
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "orderStatusList") {
          this.searchForm[item.prop] = item.value ? [item.value] : [];
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleExportData() {
    formDownload(
      `${window.API_URL}/order/export`,
      Object.assign(
        {
          clientType: "1"
        },
        this.searchForm
      )
    );
  }
  handleLinkCommand(url) {
    this.$router.push(url);
  }
  verificationCode: string = ""; // 核销码
  showOrderVaildCode: boolean = false; // 提否显示核销弹窗
  validCodeId: string = ""; // 将要核销的订单id
  handleVerificationCode() {
    if (!this.verificationCode) {
      this.$message.error(t("service.please-senter-verification-code"));
      return;
    }
    this.onlineVerificationCode({
      orderNo: this.validCodeId,
      verificationCode: this.verificationCode
    }).then(data => {
      this.$message.success(`${t("service.order")}“${this.validCodeId}”${t("test.have-been-completed")}`);
      this.showOrderVaildCode = false;
      this.loadListData();
      if (data.data.validateInventoryAlert === "1") {
        const partCodeList = this.activeRow.partsDetail.map(item => item.partsCode);
        if (partCodeList && partCodeList.length > 0) {
          this.queryInventoryAndNotice(partCodeList);
        }
      }
    });
  }

  handleComplete(row) {
    console.log(row);
    this.completeOrder({
      orderNo: row.orderNo
    }).then(
      data => {
        this.$message.success(t("base.success") as string);
        this.loadListData();
        if (data.data.validateInventoryAlert === "1") {
          const partCodeList = row.partsDetail.map(item => item.partsCode);
          if (partCodeList && partCodeList.length > 0) {
            this.queryInventoryAndNotice(partCodeList);
          }
        }
      },
      data => {
        if (data.code === "speedbiz.order.order-status-not-match") {
          this.showPickingTips = true;
        } else {
          this.$message.error(data.message);
        }
      }
    );
  }

  activeRow: any = {};
  handleVerification(row) {
    this.activeRow = row;
    this.validCodeId = row.orderNo;
    this.showOrderVaildCode = true;
  }
  handleDispatch() {
    let { href } = this.$router.resolve({
      path: `/service/dispatch-worker/index`
    });
    window.open(href, "_blank");
  }
  searchParts(partsName) {
    this.getPartsList({
      pageNum: 1,
      pageSize: 20,
      searchKey: partsName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []).map(item => {
        return {
          label: item.partsName,
          value: item.partsCode
        };
      });
    });
  }
  handleSearchServiceItemList(serviceItemName = "") {
    this.getServiceItemList({
      pageSize: 20,
      pageNum: 1,
      searchKey: serviceItemName
    }).then(data => {
      this.serviceItemList = this.$safeValue(data, "data.list", []).map(item => {
        return {
          label: item.serviceName,
          value: item.serviceCode
        };
      });
    });
  }
  handlePicking(row) {
    this.$router.push(`/inventory/out-warehouse-view/${row.outboundNo}`);
  }
  handleInvoice(row) {
    this.$router.push(`/service/make-invoice/${row.orderNo}`);
  }
  handleSettlement(row) {
    this.$router.push(`/service/cashier/${row.orderNo}`);
  }
  handleEdit(row) {
    this.$router.push(`/service/edit/${row.orderNo}`);
  }
  handleLinkArrive(row) {
    // 乘用小程序走天猫流程
    if (row.processType === "TMALL") {
      // 天猫订单走录入到店，非天猫走正常到店
      this.$router.push(`/service/arrive/input/${row.orderNo}`);
    } else {
      this.$router.push(`/service/edit/${row.orderNo}?pageType=arrive`);
    }
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleCommand(command, row) {
    if (command === "Email") {
      this.email({ orderNo: row.orderNo }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "SMS") {
      this.sms({ orderNo: row.orderNo }).then(res => {
        if (res.code === "0") {
          this.$message.success(t("v210831.sent-successfully"));
        }
      });
    } else if (command === "Print") {
      this.getUri({ orderNo: row.orderNo }).then(res => {
        if (res.code === "0") {
          window.open(res.data);
        }
      });
    } else if (command === "Share") {
      this.getUri({ orderNo: row.orderNo }).then(res => {
        if (res.code === "0") {
          this.$copyText(res.data).then(() => this.$message.success(t("v210831.copy-succeeded")));
        }
      });
    }
  }
  // ///
}
